import { useMemo } from "react";
import { useTheme } from "./useTheme";

export interface ChartColors {
  brand: string;
  brandStrong: string;
  coral: string;
  success: string;
  info: string;
  warning: string;
  premium: string;
  text: string;
  textSecondary: string;
  textTertiary: string;
  grid: string;
  surface: string;
}

/**
 * Recharts SVG'lari CSS var'larni to'g'ridan-to'g'ri tushunmaydi —
 * resolved hex qiymatlarni token'lardan o'qib beramiz.
 * Theme almashsa qayta hisoblanadi.
 */
export function useChartColors(): ChartColors {
  const theme = useTheme();

  return useMemo(() => {
    const style = getComputedStyle(document.documentElement);
    const token = (name: string) => style.getPropertyValue(name).trim();

    return {
      brand: token("--brand"),
      brandStrong: token("--brand-strong"),
      coral: token("--accent-coral"),
      success: token("--accent-success"),
      info: token("--accent-info"),
      warning: token("--accent-warning"),
      premium: token("--accent-premium"),
      text: token("--text-primary"),
      textSecondary: token("--text-secondary"),
      textTertiary: token("--text-tertiary"),
      grid: token("--border-strong"),
      surface: token("--bg-surface"),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);
}
